import React from "react";
import { Timeline, Collapse } from "antd";
import FeedItem from "./FeedItem";
import { CaretRightOutlined } from "@ant-design/icons";
import {
  ScheduleOutlined,
  SolutionOutlined,
  BarsOutlined,
} from "@ant-design/icons";
const { Panel } = Collapse;

const iconStyle = {
  fontSize: "16px",
};

const getTypeIcon = (type) => {
  switch (type) {
    case "task":
      return <BarsOutlined style={{ ...iconStyle, color: "#4BC076" }} />;
    case "event":
      return <ScheduleOutlined style={{ ...iconStyle, color: "#EB7092" }} />;
    default:
      return <SolutionOutlined style={{ ...iconStyle, color: "#48C3CC" }} />;
  }
};

const FeedSection = (props) => {
  const {
    activities,
    title,
    activeKey,
    entity,
    entityId,
    branchId,
    reload,
    onEditActivity,
  } = props;
  return (
    <Collapse
      bordered={false}
      defaultActiveKey={[activeKey]}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
      className="custom-collapse-section feed"
    >
      <Panel header={title} key={activeKey}>
        <Timeline
          style={{ padding: "0 10px" }}
          pendingDot={null}
          items={activities.map((record, index) => {
            const { task } = record;
            const type = task ? task.type : "event";
            return {
              children: (
                <FeedItem
                  key={index}
                  record={record}
                  entity={entity}
                  entityId={entityId}
                  branchId={branchId}
                  reload={reload}
                  onEditActivity={onEditActivity}
                />
              ),
              dot: getTypeIcon(type),
            };
          })}
        />
      </Panel>
    </Collapse>
  );
};
export default FeedSection;
